import bannerImg from './banners/woman-helping-man-gym.jpg';

const npsProgramaTreino = (t) => ({
    id: 'nps-programa-treino',
    title: t('templates.items.npsProgramaTreino.title'),
    description: t('templates.items.npsProgramaTreino.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.npsProgramaTreino.summary.recommendationScore'),
        t('templates.items.npsProgramaTreino.summary.scoreReason'),
        t('templates.items.npsProgramaTreino.summary.biggestResult'),
        t('templates.items.npsProgramaTreino.summary.improvementSuggestion'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.npsProgramaTreino.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.npsProgramaTreino.form.review.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.npsProgramaTreino.form.review.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.npsProgramaTreino.form.review.recommendation.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.npsProgramaTreino.form.review.recommendation.minLabel'),
                            maxLabel: t('templates.items.npsProgramaTreino.form.review.recommendation.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: t('templates.items.npsProgramaTreino.form.review.scoreReason.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: t('templates.items.npsProgramaTreino.form.review.biggestResult.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: t('templates.items.npsProgramaTreino.form.review.improvement.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default npsProgramaTreino;
